import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function DfsReducer(state = initialState.dfs, action: any) {
  switch (action.type) {
    case types.SAVE_DFS_SUCCESS:
      return action.dfs;
    default:
      return state;
  }
}
